import React, { FC } from "react";
import {
  Container,
  BackText,
  ArrowCloseImg,
  OnClickArea
} from './styles'
import Back from './arrowClose.svg'
import { useBackNavigation } from '../../context/navigationContext'
import { useTranslation } from 'react-i18next'

type BackArrowProps = {
  title?: string;
  onClick?: () => void;
  fallbackPath?: string;
  fallbackTitle?: string;
  customStyles?: React.CSSProperties | Record<string, string>;
}

const BackArrow: FC<BackArrowProps> = ({ title, onClick, fallbackPath, fallbackTitle, customStyles }) => {
  const { goBack, previousPageTitle } = useBackNavigation(fallbackPath);
  const [t] = useTranslation();

  const displayTitle = title || (
    previousPageTitle
      ? `${t("BACK_TO")} ${previousPageTitle}`
      : fallbackTitle
        ? `${t("BACK_TO")} ${fallbackTitle}`
        : t("BACK_TO")
  );

  const handleClick = onClick || goBack;

  return (
    <Container customStyles={customStyles}>
      <OnClickArea onClick={handleClick}>
        <ArrowCloseImg src={Back}/>
        <BackText>{displayTitle}</BackText>
      </OnClickArea>
    </Container>
  )
}

export default BackArrow
